import Agent, { type AgentInstances, type AgentParams } from './Agent';

class CustomUserAgent extends Agent {
  static name = 'CustomUserAgent';

  static available(
    _agentParams: AgentParams,
    _agentInstances: AgentInstances
  ): boolean {
    return window.currentAccount?.hasGeneralAiAssistant || false;
  }

  publicName(): string {
    return (
      this.controller.state.customAgents.find(
        agent => agent.id === this.agentParams.ai_user_agent_id
      )?.name || ''
    );
  }
}
Agent.register(CustomUserAgent);
